import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      subhead: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 'bold',
        color: sicrediColors.secondarySicrediDarker,
        marginTop: theme.spacing(1),
      },
      botaoContainer: {
        paddingTop: '32px',
      },
      botao: {
        marginBottom: theme.spacing(1),
      },
      selectIcon: {
        width: 24,
        height: 24,
        color: sicrediColors.primarySicredi,
      },
    }),
  { name: 'PageParametros' }
);
